<div
  riResolutionUiElementDimensions
  class="overflow-auto p-3 [scrollbar-gutter:stable] [scrollbar-width:thin]"
>
  <ng-content></ng-content>
  <div #anchorRef></div>
  @if (message()) {
    <ng-container [ngTemplateOutlet]="message()!"></ng-container>
  }

</div>
@if (bottomHasBeenReached() && hasMoreItems()) {
  <div class="absolute bottom-3 right-3" @loadmore>
    <button mat-fab (click)="onLoadMore()">
      <mat-icon fontSet="material-symbols-outlined">south</mat-icon>
    </button>
  </div>
}
